/**
2  *  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
3  *
4  * THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
5  * AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
6  * WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
7  * TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
8  * AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
9  * INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
10  * PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
11  * CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
12  * OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
13  * ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
14  * THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
15  */


import { Component, ViewEncapsulation, OnInit, Output, EventEmitter, HostListener } from '@angular/core';
import { ServiceBasicInfo, ServicesResponse } from '../model/serviceitemsresponse';
import { ServicesFilterInfo } from '../model/serviceitemsfilterinfo';
import { ServiceItemsListService } from '../services/serviceitems.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ZSDTranslateService } from '../../../../common/zsd-translate.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { CustomerPreferenceService } from '../../../preference/customerpreference.service';
import { CustomerPreferenceResponse } from '../../../preference/customerpreference.model';
import { BannerComponent } from '../../../view/banner/banner.component';
import { SpinnerService } from '../../../../shared/spinner/spinner.service';
import { CommonConstants } from '../../../../common/constants/common-constants';
import { ItemCategoriesResultEntity } from '../../shared/model/itemcategoriesresponse';
import { ItemTypesResultEntity } from '../../shared/model/itemtypesresponse';
declare var $: any;

@Component({
  selector: 'zsd-serviceslist',
  templateUrl: '../view/serviceitemslist.component.html',
  styleUrls: ['../view/serviceitemslist.component.scss'
  ],
  providers: [],
  encapsulation: ViewEncapsulation.None
})
export class ServiceItemsListComponent implements OnInit {
  @Output() openfilter = new EventEmitter<boolean>();
  itemDataFound = true;
  noRecords;
  isActive = true;
  servicesCount: number;
  optionSelected: string;
  serviceCatalogCount: number;
  myServiceTab = 'myservices';
  serviceCatalogTab = 'servicecatalog';
  showServiceCatalogTab: boolean;
  itemResultsCount = 0;
  servicesPerPage = 20;
  page = 0;
  sortBy = 'lastActionDate';
  sortOrder = 'DESC';
  isLoading = false;
  maxNoOfItems;
  isItemslist;
  scrollEndReached = false;
  isDesc = false;
  column;

  sitemsBasicInfoResponse = new Array<ServiceBasicInfo>();
  sitemsListResponse: ServicesResponse = new ServicesResponse();
  sitemsfilterInfo: ServicesFilterInfo = new ServicesFilterInfo();
  spinnerStart = true; // adding for showing spinner while loading instead of No request message

  myServiceTabClicked;
  serviceCatalogTabClicked;
  myServices = 'myservices';
  allServices = 'all';

  categoryResults = new Array<ItemCategoriesResultEntity>();
  itemTypesResults = new Array<ItemTypesResultEntity>();

  static selectedCategories = null;
  static selectedItemTypes = null;
  static categoryIds = null;

  constructor(public sitemsService: ServiceItemsListService,
    private route: ActivatedRoute, public zsdTranslate: ZSDTranslateService, public spinnerService: SpinnerService,
    public http: HttpClient, public customerPreferenceService: CustomerPreferenceService,
    private router: Router) {
  }


  ngOnInit() {
    /* To refresh Global search dropdown */
    BannerComponent.refreshGlobalSearchDropdown.next(false);
    this.resetFilter();
    this.initServicePreferencesAndCount();
    this.sort('itemName');
  }

  sort(property) {

    this.initializeServiceItemsParameters();
    $('#property').removeClass('fa fa-sort');
    this.isDesc = !this.isDesc;
    this.column = property;
    if (this.isDesc === true) {
      this.sortOrder = 'ASC';
    } else {
      this.sortOrder = 'DESC';
    }
    this.sortBy = property;

    this.initFilter();
    this.applyFilterParamaeter(this.sitemsfilterInfo);
    this.isLoading = true;
    this.spinnerService.show();
  }

  initServicePreferencesAndCount(): void {
    // get privilege for service catalog
    this.customerPreferenceService.getPreferenceList().toPromise()
      .then((preference: CustomerPreferenceResponse) => {
        this.showServiceCatalogTab = preference.showAllService;
      });

    // get count for  myservice and servicecatalog list
    this.sitemsService.getServiceCount().subscribe(
      (val: number) => {
        this.servicesCount = val;
      });
    this.sitemsService.getServiceCatalogCount().subscribe(
      (val: number) => {
        this.serviceCatalogCount = val;
      });
  }
  initializeServiceItemsParameters() {
    this.isLoading = false;
    this.page = 0;
    this.isItemslist = false;
    this.sitemsBasicInfoResponse = [];
    this.sitemsfilterInfo = new ServicesFilterInfo();
    this.sitemsListResponse = new ServicesResponse();
  }
  initFilter() {
    let categoryIds = new Array<number>();
    let itemTypeIds = new Array<number>();

    this.route.queryParams.subscribe(params => {
      if (params['searchTerm']) {
        this.sitemsfilterInfo.searchTerm = JSON.parse(params['searchTerm']);
      }
      if (params['categoryIds']) {
        categoryIds = JSON.parse(params['categoryIds']);
      }
      if (params['itemTypeIds']) {
        itemTypeIds = JSON.parse(params['itemTypeIds']);
      }
      if (params['serviceType']) {
        this.sitemsfilterInfo.serviceType = JSON.parse(params['serviceType']);
        if (this.sitemsfilterInfo.serviceType === this.myServices) {
             this.optionSelected = this.myServiceTab;
        }
        if (this.sitemsfilterInfo.serviceType === this.allServices) {
          this.optionSelected = this.serviceCatalogTab;
      }
      } else {
        this.sitemsfilterInfo.serviceType  = this.myServices;
        this.optionSelected = this.myServiceTab;
      }
    });
    this.sitemsfilterInfo.categoryIds = categoryIds;
    this.sitemsfilterInfo.itemTypeIds = itemTypeIds;
  }

  applyFilterOnServiceTypeChange() {
    let categoryIds = new Array<number>();
    let itemTypeIds = new Array<number>();

    this.route.queryParams.subscribe(params => {
      if (params['searchTerm']) {
        this.sitemsfilterInfo.searchTerm = JSON.parse(params['searchTerm']);
      }
      if (params['categoryIds']) {
        categoryIds = JSON.parse(params['categoryIds']);
      }
      if (params['itemTypeIds']) {
        itemTypeIds = JSON.parse(params['itemTypeIds']);
      }
    });

    this.sitemsfilterInfo.categoryIds = categoryIds;
    this.sitemsfilterInfo.itemTypeIds = itemTypeIds;

    this.categoryResults = this.categoryResults.filter(category => category.checked === true);
    this.itemTypesResults = this.itemTypesResults.filter(itemType => itemType.checked === true);

    for (let itemCategory of this.categoryResults) {
      categoryIds.push(itemCategory.categoryId);
    }

    for (let itemType of this.itemTypesResults) {
      itemTypeIds.push(itemType.itemTypeId);
    }

    if (this.sitemsfilterInfo.serviceType === '') {
      this.sitemsfilterInfo.serviceType = this.myServices;
    }
    if (this.sitemsfilterInfo.serviceType !== null) {
     this.sitemsfilterInfo.serviceType = JSON.stringify(this.sitemsfilterInfo.serviceType);
    }
    if (this.sitemsfilterInfo.searchTerm !== null) {
      this.sitemsfilterInfo.searchTerm = JSON.stringify(this.sitemsfilterInfo.searchTerm);
    }

    if (categoryIds.length > 0) {
      ServiceItemsListComponent.selectedCategories = JSON.stringify(categoryIds);
      this.sitemsfilterInfo.categoryIds = categoryIds;
    }
    if (itemTypeIds.length > 0) {
      ServiceItemsListComponent.selectedItemTypes = JSON.stringify(itemTypeIds);
      this.sitemsfilterInfo.itemTypeIds = itemTypeIds;
    }

    let navigationExtras: NavigationExtras = {
      queryParams: {
        'searchTerm':  this.sitemsfilterInfo.searchTerm,
        'categoryIds': ServiceItemsListComponent.selectedCategories,
        'itemTypeIds': ServiceItemsListComponent.selectedItemTypes,
        'serviceType':  this.sitemsfilterInfo.serviceType
      },
      queryParamsHandling: 'merge'
    };

    this.router.navigateByUrl('/my-profile', { skipLocationChange: true }).then(() =>
      this.router.navigate([CommonConstants.SERVICES_COMPONENT], navigationExtras));
  }


  resetFilter() {
    ServiceItemsListComponent.selectedCategories = null;
    ServiceItemsListComponent.selectedItemTypes = null;
    this.categoryResults.forEach(category => category.checked = false);
    this.itemTypesResults.forEach(itemType => itemType.checked = false);
  }

  applyFilterParamaeter(sitemsfilterInfo: ServicesFilterInfo) {
    if (sitemsfilterInfo) {
      if (sitemsfilterInfo.serviceType === null) {
        this.optionSelected = this.myServiceTab;
        sitemsfilterInfo.serviceType = this.myServices;
      }
      this.getServiceItemsList(this.page, this.sortBy, this.sortOrder, sitemsfilterInfo);
    } else {
      sitemsfilterInfo.searchTerm = '';
      sitemsfilterInfo.categoryIds = [];
      sitemsfilterInfo.itemTypeIds = [];
      sitemsfilterInfo.serviceType = this.myServices;
      this.getServiceItemsList(this.page, this.sortBy, this.sortOrder, sitemsfilterInfo);
    }
  }
  getServiceItemsList(pageNo: number, sortBy: string, sortOrder: string, sitemsfilterInfo: ServicesFilterInfo) {
    let params = new HttpParams()
      .set('offset', this.page.toString())
      .set('limit', this.servicesPerPage.toString())
      .set('sortBy', this.sortBy)
      .set('sortOrder', this.sortOrder);

    if (sitemsfilterInfo.itemTypeIds) {
      for (let i = 0; i < sitemsfilterInfo.itemTypeIds.length; i++) {
        params = params.append('itemTypeId', sitemsfilterInfo.itemTypeIds[i].toString());
      }
    }

    if (sitemsfilterInfo.categoryIds) {
      for (let i = 0; i < sitemsfilterInfo.categoryIds.length; i++) {
        params = params.append('itemCategoryId', sitemsfilterInfo.categoryIds[i].toString());
      }
    }

    if (sitemsfilterInfo.searchTerm !== null && sitemsfilterInfo.searchTerm) {
      params = params.append('searchTerm', sitemsfilterInfo.searchTerm);
    }

    if (sitemsfilterInfo.serviceType === null || sitemsfilterInfo.serviceType === this.myServices) {
      this.optionSelected = this.myServiceTab;
      params = params.append('itemOption', 'MYSERVICEITEMS');
    }

    if (sitemsfilterInfo.serviceType !== null &&  sitemsfilterInfo.serviceType === this.allServices) {
      this.optionSelected = this.serviceCatalogTab;
      params = params.append('itemOption', 'SERVICECATALOG');
    }

    if (!this.isLoading) {
      this.isLoading = true;
      this.spinnerService.show();
      if (pageNo === -1) {
        this.isLoading = true;
        this.spinnerService.show();
        this.page = 0;
        this.sortBy = sortBy;
        this.sortOrder = sortOrder;
        this.initializeServiceItemsParameters();
        pageNo = 0;
      }
       this.sitemsService
      .getServiceItemsList(params)
      .subscribe(
        (sitemsResponse: ServicesResponse) => {
          this.maxNoOfItems = sitemsResponse.resultCount;
          this.servicesCount = sitemsResponse.myServiceCount;
          this.serviceCatalogCount = sitemsResponse.serviceCatalogCount;
          if (this.maxNoOfItems > 0) {
            this.isItemslist = true;
            this.scrollEndReached = false;
          }
          this.sitemsBasicInfoResponse = this.sitemsBasicInfoResponse.concat(
            sitemsResponse.results
          );
          this.page++;
          if (this.sitemsBasicInfoResponse.length >= this.maxNoOfItems) {
            // reached end of list
            this.scrollEndReached = true;
          }
          this.isLoading = false;
          this.spinnerStart = false;
        },

        err => {
          console.error(err.error);
          this.isItemslist = false;
          this.isLoading = false;
          this.spinnerStart = false;
        }
      );
    }

  }

  onChangeServiceType(option: string) {
    this.isLoading = false;
    this.page = 0;
    this.sitemsBasicInfoResponse = [];
    if (option === this.myServiceTab) {
      this.optionSelected = this.myServiceTab;
      this.sitemsfilterInfo.serviceType = this.myServices;
      this.myServiceTabClicked = true;
    }
    if (option === this.serviceCatalogTab) {
      this.optionSelected = this.serviceCatalogTab;
      this.sitemsfilterInfo.serviceType = this.allServices;
      this.serviceCatalogTabClicked = true;
    }
    this.applyFilterOnServiceTypeChange();

  }


  scrollEnd() {
    if (!this.scrollEndReached) {
      this.initFilter();
      this.getServiceItemsList(this.page, this.sortBy, this.sortOrder, this.sitemsfilterInfo);
    }
  }
  scrollCur() {
  }

  trackByItems(index) {
    return index;
  }
  @HostListener('window:beforeunload', ['$event']) unloadHandler() {
    new ServiceItemsListComponent(
      this.sitemsService, this.route, this.zsdTranslate,
      this.spinnerService, this.http, this.customerPreferenceService, this.router);
    window.scrollTo(0, 0);
  }

  openFilter() {
    this.openfilter.emit(true);
  }

  getServiceItemDetail(sItem: ServiceBasicInfo) {
    let tab;
       if (this.myServiceTabClicked || this.sitemsfilterInfo.serviceType === this.myServices) {
         tab = this.myServiceTab ;
      }
      if (this.serviceCatalogTabClicked || this.sitemsfilterInfo.serviceType === this.allServices) {
        tab =  this.serviceCatalogTab ;
      }
  let pathUrl = CommonConstants.SERVICES_COMPONENT;
  this.router.navigateByUrl('/services', { skipLocationChange: true }).then(() =>
  this.router.navigate([pathUrl, tab, sItem.itemId]));
}

}
